/**
 * 预定义固定调色板（10 色）
 * - 主流 UI 风格：浅淡柔和、有层次感、无重复
 * - 参考品牌：Vercel / Cursor / Linear / Discord / Notion / OpenAI
 * - 基于 #3354DC / #5B6AEB / #3D8679 官方参考色扩展
 * - 去掉灰色系重复，每个颜色色相差距明显
 */
export const BRANCH_COLOR_PALETTE = [
  "#2B5CE6",  // 01 品牌蓝
  "#6172F3",  // 02 靛蓝
  "#7A5AF8",  // 03 紫
  "#9B8AFB",  // 04 浅紫
  "#0086C9",  // 05 深天蓝
  "#36BFFA",  // 06 亮天蓝
  "#444CE7",  // 07 深靛
  "#5925DC",  // 08 深紫
  "#4E5BA6",  // 09 灰蓝
  "#2E90FA",  // 10 蓝
];

/**
 * 按 index 循环取色（超过调色板长度则从 0 重新开始）
 */
export const getBranchColor = (index) => {
  return BRANCH_COLOR_PALETTE[index % BRANCH_COLOR_PALETTE.length];
};
